export default __webpack_public_path__ + "static/media/illustration-elements_icon-github_02.4bd76ec7.svg";